import { useEffect, useState } from "react";
import { Users, UserPlus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";

const EMPTY = { name: "", email: "", password: "" };

export const TeamSettings = () => {
  const [admins, setAdmins] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  useEffect(() => {
    http.get("/admin/users").then((r) => setAdmins(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await http.post("/admin/users", form);
      setAdmins((a) => [...a, r.data]);
      setForm(EMPTY);
      toast.success(`${r.data.email} can now log in at /admin`);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  const remove = async (a) => {
    if (!window.confirm(`Remove access for ${a.email}?`)) return;
    try {
      await http.delete(`/admin/users/${a.id}`);
      setAdmins((list) => list.filter((x) => x.id !== a.id));
      toast.success("Access removed");
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <section className="mt-4 border border-[var(--line)] bg-[var(--char)] p-6" data-testid="team-settings">
      <p className="flex items-center gap-2 font-mono-x text-[12px] uppercase tracking-[0.14em] text-zinc-300"><Users className="w-4 h-4 text-[var(--orange)]" />Dashboard access</p>
      <ul className="mt-3 divide-y divide-[var(--line)]" data-testid="team-list">
        {admins.map((a) => (
          <li key={a.id} className="flex items-center justify-between gap-3 py-2.5 text-sm">
            <span className="text-zinc-200 break-all">{a.name ? `${a.name} · ` : ""}{a.email}{a.is_you && <span className="ml-2 text-xs text-[var(--orange)]">(you)</span>}</span>
            {!a.is_you && (
              <button onClick={() => remove(a)} aria-label={`Remove ${a.email}`} data-testid={`team-remove-${a.id}`} className="text-zinc-400 hover:text-red-400 transition-colors"><Trash2 className="w-4 h-4" /></button>
            )}
          </li>
        ))}
      </ul>
      <form onSubmit={add} className="mt-4 grid gap-2 sm:grid-cols-[1fr_1.4fr_1.2fr_auto]" data-testid="team-add-form">
        <input className="field" placeholder="Name" value={form.name} onChange={set("name")} data-testid="team-name-input" />
        <input className="field" type="email" required placeholder="Partner's email" value={form.email} onChange={set("email")} data-testid="team-email-input" />
        <input className="field" type="password" required minLength={8} placeholder="Password (8+ chars)" value={form.password} onChange={set("password")} data-testid="team-password-input" />
        <button disabled={busy} className="btn-orange justify-center px-5 py-3" data-testid="team-add-btn"><UserPlus className="w-4 h-4" /><span>Add</span></button>
      </form>
      <p className="mt-2 text-xs text-zinc-400">They log in at /admin with this email and password.</p>
    </section>
  );
};
